import { Badge } from "@freightsimple/ui-core/Display/Badge";
import { TextCell } from "@freightsimple/ui-core/Cells/TextCell";
import { TimestampCell } from "@freightsimple/ui-core/Cells/TimestampCell";
import type { WebhookDelivery } from "@freightsimple/generated-dashboard-openapi-client/models/WebhookDelivery";
import { asOffsetDateTime } from "@freightsimple/time/branded-types";
import {
  describeWebhookDeliveryState,
  webhookDeliveryStateVariant,
} from "./webhooksLabels";

/** The cells the deliveries table and the dialog's attempt history both render. */

export function webhooksOutcomeBadge(delivery: WebhookDelivery) {
  return (
    <Badge
      label={describeWebhookDeliveryState(delivery.state)}
      variant={webhookDeliveryStateVariant(delivery.state)}
    />
  );
}

export function webhooksResponseCell(delivery: WebhookDelivery) {
  return delivery.httpStatus !== undefined ? (
    <TextCell value={`HTTP ${delivery.httpStatus}`} />
  ) : (
    <TextCell value={delivery.errorMessage} size="sm" color="muted" />
  );
}

export function webhooksWhenCell(delivery: WebhookDelivery) {
  return (
    <TimestampCell
      value={asOffsetDateTime(delivery.createdAt.toISOString())}
      relative
    />
  );
}
